<template>
  <div class="quill-wrap">
    <quill-editor
      v-model="_content_"
      ref="myQuillEditor"
      :options="editorOption"
    >
    </quill-editor>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

import Quill from 'quill'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'

import {
  container,
  ImageExtend,
  QuillWatch,
} from 'quill-image-super-solution-module'
import store from '@/store/store'
Quill.register('modules/ImageExtend', ImageExtend)

// import imageResize from 'quill-image-resize-module'
// Quill.register('modules/imageResize', imageResize)

export default {
  components: { quillEditor },

  props: {
    content: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'content',
    event: 'contentChange',
  },
  computed: {
    _content_: {
      get() {
        return this.content
      },
      set(val) {
        this.$emit('contentChange', val)
      },
    },
  },
  data() {
    return {
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            headers: (xhr) => {
              xhr.setRequestHeader('Token', store.state.userInfo.token)
            },
            action: urlPerfix + '/images/upload?t=pub',
            response: (res) => {
              return originImagePath + res.data
            },
          },
          // imageResize: {
          //   displayStyles: {
          //     backgroundColor: 'black',
          //     border: 'none',
          //     color: 'white',
          //   },
          //   modules: ['Resize', 'DisplaySize', 'Toolbar'],
          // },
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['image'],
            ],
            handlers: {
              image: function () {
                let fileInput = document.querySelector('.quill-image-input')
                if (fileInput === null) {
                  fileInput = document.createElement('input')
                  fileInput.setAttribute('type', 'file')
                  fileInput.setAttribute(
                    'accept',
                    'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'
                  )
                  fileInput.classList.add('quill-image-input')
                  fileInput.style.display = 'none'
                  // 监听选择文件
                  fileInput.addEventListener('change', function () {
                    let self = QuillWatch.active
                    self.file = fileInput.files[0]
                    fileInput.value = ''
                    // 如果图片限制大小
                    if (
                      self.config.size &&
                      self.file.size >= self.config.size * 1024 * 1024 &&
                      self.config.loading
                    ) {
                      self.quillLoading.classList.remove(
                        'extend-upload-success'
                      )
                      self.quillLoading.classList.add(
                        'extend-upload-warning-color'
                      )
                      self.quillLoading.innerHTML = '图片大小超过限制'
                      setTimeout(function () {
                        self.quillLoading.classList.remove(
                          'extend-upload-warning-color'
                        )
                        self.quillLoading.classList.add('extend-upload-success')
                      }, 1500)
                      return
                    }
                    if (self.config.action) {
                      self.uploadImg(self.config.change)
                    } else {
                      self.toBase64()
                    }
                  })
                  document.body.appendChild(fileInput)
                }

                QuillWatch.emit(this.quill.id)
              },
            },
          },
        },
      },
      //   editorOption: {
      //     placeholder: '请输入内容',
      //     modules: {
      //       toolbar: [
      //         ['bold', 'italic', 'underline'], // 加粗，斜体，下划线，删除线
      //         ['blockquote'], //引用，代码块
      //         [{ list: 'ordered' }, { list: 'bullet' }], // 有序列表，无序列表
      //         [{ indent: '-1' }, { indent: '+1' }], // 缩进
      //         [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
      //         [{ color: [] }], // 颜色选择
      //         [{ align: [] }], // 居中
      //       ],
      //     },
      //   },
    }
  },
}
</script>